"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var components_lib_1 = require("@dynamynd/components-lib");

var core_1 = require("@dynamynd/core");

var responsive_1 = require("@dynamynd/responsive");

var routes_1 = require("@dynamynd/routes");

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var react_redux_1 = require("react-redux");

var redux_1 = require("redux");

var styled_components_1 = __importDefault(require("styled-components"));

var store_1 = require("../../store");

var index_1 = require("../index");

var SectionSummary = react_1.default.memo(function (_a) {
  var width = _a.width,
      activeBreakpoint = _a.activeBreakpoint,
      title = _a.title,
      modulesViewData = _a.modulesViewData,
      navigateTo = _a.navigateTo,
      showPaymentModal = _a.showPaymentModal,
      withAvailableModules = _a.withAvailableModules;

  var navigateHandler = function navigateHandler() {
    return navigateTo(routes_1.RoutesKeysEnum.dashboard);
  };

  return react_1.default.createElement(Container, null, react_1.default.createElement(exports.SectionContentRowCentered, {
    activeBreakpoint: activeBreakpoint,
    screenWidth: width
  }, react_1.default.createElement(components_lib_1.ColumnCenteredResponsive, {
    activeBreakpoint: activeBreakpoint,
    xl: 100
  }, react_1.default.createElement(TitleWithSpacer, null, title), withAvailableModules && react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(index_1.AvailableModules, {
    data: modulesViewData,
    displayFilters: false,
    showPaymentModal: showPaymentModal
  }), react_1.default.createElement(ButtonSpacer, {
    activeBreakpoint: activeBreakpoint
  }, react_1.default.createElement(components_lib_1.Button, {
    text: "Go To Dashboard",
    uppercase: true,
    type: components_lib_1.ButtonTypeEnum.primary,
    onPress: navigateHandler
  }))), react_1.default.createElement(ShapeContainer, null, react_1.default.createElement(ShapeImage, {
    source: {
      uri: components_lib_1.appConfig.images.addOnsModulesSummarySectionOwl
    }
  })))));
});
var Container = styled_components_1.default(react_native_1.View)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding-top: 60px;\n    background: linear-gradient(180deg, #fff4d8 0%, #f6e8d6 8%);\n"], ["\n    padding-top: 60px;\n    background: linear-gradient(180deg, #fff4d8 0%, #f6e8d6 8%);\n"])));
var TitleWithSpacer = styled_components_1.default(components_lib_1.Title)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin-bottom: 40px;\n"], ["\n    margin-bottom: 40px;\n"])));
var ButtonSpacer = styled_components_1.default(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      rest = __rest(_a, ["activeBreakpoint"]);

  return react_1.default.createElement(react_native_1.View, __assign({}, rest));
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-top: ", "px;\n"], ["\n    margin-top: ", "px;\n"])), function (_a) {
  var activeBreakpoint = _a.activeBreakpoint;
  return responsive_1.isSmall(activeBreakpoint) ? 0 : responsive_1.isMedium(activeBreakpoint) ? 14 : 26;
});
exports.SectionContentRowCentered = styled_components_1.default(function (_a) {
  var screenWidth = _a.screenWidth,
      activeBreakpoint = _a.activeBreakpoint,
      rest = __rest(_a, ["screenWidth", "activeBreakpoint"]);

  return react_1.default.createElement(components_lib_1.RowCenteredResponsive, __assign({}, rest));
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    position: relative;\n    align-items: flex-end;\n    height: 100%;\n    max-width: 1140px;\n    margin: 0 auto;\n    width: ", "px;\n    padding-bottom: ", "px;\n"], ["\n    position: relative;\n    align-items: flex-end;\n    height: 100%;\n    max-width: 1140px;\n    margin: 0 auto;\n    width: ", "px;\n    padding-bottom: ", "px;\n"])), function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      screenWidth = _a.screenWidth;
  return setSectionContentRowCenteredWidth(activeBreakpoint, screenWidth);
}, function (_a) {
  var activeBreakpoint = _a.activeBreakpoint;
  return setSectionContentRowCenteredPadding(activeBreakpoint);
});

function setSectionContentRowCenteredPadding(activeBreakpoint) {
  if (responsive_1.isSmall(activeBreakpoint)) {
    return 90;
  }

  if (responsive_1.isExtraLarge(activeBreakpoint)) {
    return 40;
  }

  return 0;
}

function setSectionContentRowCenteredWidth(activeBreakpoint, screenWidth) {
  if (responsive_1.isExtraLarge(activeBreakpoint)) {
    return 1140;
  }

  var gutter = core_1.getActiveGutterSize(activeBreakpoint);
  return screenWidth - 2 * gutter;
}

var ShapeContainer = responsive_1.withResponsiveMeta(styled_components_1.default(function (_a) {
  var width = _a.width,
      rest = __rest(_a, ["width"]);

  return react_1.default.createElement(react_native_1.View, __assign({}, rest));
})(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1;\n    width: 842px;\n    max-width: ", "px;\n    height: 361px;\n    overflow: hidden;\n"], ["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1;\n    width: 842px;\n    max-width: ", "px;\n    height: 361px;\n    overflow: hidden;\n"])), function (_a) {
  var width = _a.width;
  return width;
}));
var ShapeImage = styled_components_1.default(react_native_1.ImageBackground)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    position: relative;\n    width: 842px;\n    height: 361px;\n"], ["\n    position: relative;\n    width: 842px;\n    height: 361px;\n"])));

var mapStateToProps = function mapStateToProps(state) {
  return {
    modulesViewData: store_1.modulesViewDataWithoutCurrentModuleSelector(state)
  };
};

var connector = react_redux_1.connect(mapStateToProps);
var hoc = redux_1.compose(connector, responsive_1.withResponsiveMeta, core_1.withNavigateTo);
exports.default = hoc(SectionSummary);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;